<template>
  <h1 v-if="patient"
      class="d-flex gap-2 align-items-center w-100 overflow-hidden">

    <router-link  class="d-md-inline d-none"
                  :to="{ name: 'Patients' }">{{ $t('patients') }}</router-link>
    <div class="d-md-inline d-none">/</div>

    <div v-if="!patientLink" class="flex-grow-1 nowrap">
      {{ patient.full_name }}
    </div>
    <router-link
        v-if="patientLink"
        class="flex-grow-0 nowrap overflow-ellipsis"
        :style="{ 'min-width': patient.full_name.length > 8 ? `80px` : `${patient.full_name.length * 8}px` }"
        :to="{ name: 'PatientVisits', params: {id: patient.id} }">
      {{ patient.full_name }}
    </router-link>

    <div v-if="patientLink && visit?.readableStart">/</div>
    <div v-if="patientLink && visit?.readableStart" class="flex-grow-0 flex-shrink-0 nowrap overflow-ellipsis">
      {{ $t('visit') }} {{ $t('from') }} {{ visit.readableStart.replace(',', '') }} ({{ formatMinutes(visit.durationMinutes) }})
    </div>

    <div v-if="patientLink && planTreatment?.message">/</div>
    <div v-if="patientLink && planTreatment?.message" class="flex-grow-0 nowrap overflow-ellipsis" style="min-width: 80px">
      {{ planTreatment.message }}
    </div>

    <div class="patient-note-span flex-shrink-1 overflow-hidden"
         style="min-width: 0;"
         v-if="showClientNote">
      <PatientNotesBlock :forceLine="true"
                         :only-important="true"
                         :notes="patient.client_notes"/>
    </div>
  </h1>
</template>

<script setup>
import PatientNotesBlock from "@/components/parts/patients/PatientNotesBlock.vue"
import {formatMinutes} from "@/extensions/filters/filters"

defineProps({
  patient: {
    type: Object,
  },
  patientLink: {
    type: Boolean,
    default: false,
  },
  visit: {
    type: Object,
  },
  planTreatment: {
    type: Object,
  },
  showClientNote: {
    type: Boolean,
    default: false,
  }
})
</script>
